import React, { useEffect, useState } from "react";
import {
  calculateAccountingTotal,
  formatAccountingTotalDisplay,
  formatCurrencyRateDisplay,
} from "./accountingTotals";
import { fetchAccountingSettings } from "./accountingSettingsApi";

export default function AccountingTotalSummary({ transactions, usdEurRate, style }) {
  const [rate, setRate] = useState(usdEurRate ?? null);
  const [rateLoaded, setRateLoaded] = useState(usdEurRate != null);

  useEffect(() => {
    const loadRate = () => {
      if (usdEurRate != null) {
        setRate(usdEurRate);
        setRateLoaded(true);
        return Promise.resolve();
      }
      return fetchAccountingSettings()
        .then((settings) => setRate(settings?.usd_eur_rate ?? null))
        .finally(() => setRateLoaded(true));
    };

    loadRate();

    const onUpdated = () => {
      fetchAccountingSettings({ force: true }).then((settings) => setRate(settings?.usd_eur_rate ?? null));
    };
    window.addEventListener("accounting-settings-updated", onUpdated);
    return () => window.removeEventListener("accounting-settings-updated", onUpdated);
  }, [usdEurRate]);

  const summary = calculateAccountingTotal(transactions, rate);
  const { totalEur, skippedUsdCount, transactionCount } = summary;

  if (!rateLoaded || !transactionCount) return null;

  const totalColor = totalEur > 0 ? "#27ae60" : totalEur < 0 ? "#c0392b" : "#333";

  return (
    <div
      style={{
        marginTop: 14,
        marginBottom: 8,
        padding: "12px 14px",
        borderRadius: 8,
        border: "1px solid #e5e5e5",
        background: "#f8faf8",
        ...style,
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Accounting total (EUR)</div>
      <div style={{ fontSize: 20, fontWeight: 800, color: totalColor }}>
        {formatAccountingTotalDisplay(totalEur)}
      </div>
      <div style={{ fontSize: 12, color: "#666", marginTop: 6 }}>
        Payments add to the total; expenses subtract. USD entries use the global currency rate.
      </div>
      {rate ? (
        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
          Rate: {formatCurrencyRateDisplay(rate)}
        </div>
      ) : null}
      {skippedUsdCount > 0 ? (
        <div style={{ fontSize: 12, color: "#b8860b", marginTop: 4 }}>
          {skippedUsdCount} USD transaction{skippedUsdCount === 1 ? "" : "s"} not included — a manager must set the currency rate.
        </div>
      ) : null}
    </div>
  );
}
